import ArticleItem from 'Components/alerts/components/ArticleItem';
import { Suspense } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { selectArticlesEnded } from 'Selector/AlertsSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Article } from 'Types/ArticleTypes';
import {
  selectLoading,
  selectSimilarArticleCountTwo,
  selectSimilarArticleLoading,
  selectSimilarArticleTwoLoading,
} from 'Selector/ArticleSector';
import {
  actions,
} from 'Slice/ArticlesSlice';
import {
  maxTablet, maxWidth, retina, smMobile,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import { isSimilarArticleScroll, isSimilarArticleScrollItem } from 'Selector/UISelector';
import NoDataFound from './NoDataFound';
import ArticleTileSkeleton from '../skeleton/ArticleTileSkeleton';

type Props = {
  articleId?: number;
  similarArticles: Article[]
  similarArticlesCount?: number
  isSimilarArticle?: boolean
};

const StyleWrapper = styled.div`
&.heightIncrease {
  height: calc(100vh - 130px);
}
  .infinite-scroll-component__outerdiv {
    margin-top: 22px;
    .infinite-scroll-component {
      overflow-y: hidden !important;
      .article-item {
        align-items: flex-start;

        .tagArticle {
          right: 0;
          top: 4px;

          @media all and (max-width: ${maxWidth}), ${retina}{
            top: 2px;
          }
        }

        .heading {
          width: calc(100% - 100px);

          @media all and (max-width: ${maxWidth}), ${retina}{
            width: calc(100% - 90px);
          }

          &.text-truncate-three-line{
            -webkit-line-clamp: 2;
          }
        }

        .text-area {
          min-width: calc(100% - 160px);
          .bottom-action-wrapper {
            .action-sharing {
              .popover-sharing {
                .ant-popover-placement-left {
                  left: 287px !important;
                  @media all and (max-width: ${maxWidth}), ${retina} {
                    left: 179px !important;
                  }
                  @media all and (max-width: ${maxTablet}) {
                    left: 179px !important;
                  }
                  @media all and (max-width: ${smMobile}) {
                    left: calc(100% - 224px) !important;
                  }
                }
              }
            }
            .bottom-tips {
              width: calc(100% - 32px);
              max-width: calc(100% - 32px);
              min-width: calc(100% - 60px);

              @media all and (max-width: ${maxWidth}), ${retina}{
                margin-top: 0;
              }
              .tips {
                width: fit-content;
              }
            }
          }
        }
      }
    }
  }
`;
const defaultProps = {
  similarArticlesCount: 0,
  isSimilarArticle: false,
  articleId: 0,
};

const ArticleInfoSimilarConcept = function ArticleInfoSimilarConcept(props: Props) {
  const {
    articleId,
    similarArticles,
    similarArticlesCount,
    isSimilarArticle,
  } = props;

  const articlesEnded: boolean = useSelector(selectArticlesEnded);
  const articleLoading = useSelector(selectLoading);
  const similarArticleloading = useSelector(selectSimilarArticleLoading);
  const similarArticleCountTwo = useSelector(selectSimilarArticleCountTwo);
  const similarArticleTwoLoading = useSelector(selectSimilarArticleTwoLoading);
  const isSimilarArticleScrollFlag: boolean = useSelector(isSimilarArticleScroll);
  const isSimilarArticleScrollItemFlag: boolean = useSelector(isSimilarArticleScrollItem);
  const loading = isSimilarArticle ? similarArticleTwoLoading : similarArticleloading;

  const dispatch = useDispatch();

  const fetchMoreArticles = () => {
    dispatch(actions.getSimilarArticle({
      article_id: articleId,
      offset: similarArticles?.length,
      isSimilarArticle,
    }));
  };

  return (
    <StyleWrapper className={classNames({
      heightIncrease: (isSimilarArticleScrollFlag
        || isSimilarArticleScrollItemFlag),
    })}
    >
      <InfiniteScroll
        dataLength={isSimilarArticle ? similarArticleCountTwo : similarArticlesCount || 0}
        next={fetchMoreArticles}
        hasMore
        loader={false}
        className="o-x-hidden"
        // height="auto"
        scrollableTarget="articleDrawerScroll"
      >

        {similarArticles?.length ? similarArticles?.map((article: Article) => {
          const alert = article?.alerts[0];
          return (
            <Suspense
              fallback={
                <div />
              }
            >
              <ArticleItem
                key={article?.articleId}
                image={article?.image}
                heading={article?.title}
                summary={article?.transcribeText}
                domain={article?.domain}
                date={article?.dateTimeStamp}
                industry={article?.companyName}
                redirectUrl={article?.url}
                articleAlert={alert?.alert}
                trigger={alert?.color}
                articleId={article?.articleId}
                isRead={article?.isRead}
                isFavorite={article?.isFavorite}
                showDrawer
                alertId={(article?.alerts && article?.alerts.length > 0
                  && article.alerts[0].alertId) || 0}
                isSimilarArticle
                companyId={article?.companyId}
                similarArticlesCount={article?.similarArticlesCount}
              />
            </Suspense>
          );
        }) : null}
        {loading && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(() => (
          <Suspense
            fallback={
              <div />
            }
          >
            <ArticleTileSkeleton />
          </Suspense>
        ))}
        {!articleLoading && similarArticles?.length < 1 && articlesEnded && (
          <Suspense
            fallback={
              <div />
            }
          >
            <NoDataFound title="No Articles Found!" />
          </Suspense>
        )}
      </InfiniteScroll>
    </StyleWrapper>
  );
};
ArticleInfoSimilarConcept.defaultProps = defaultProps;
export default ArticleInfoSimilarConcept;
